import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'
import { TABLE_ROUNDS, FIELD_KEY_SEPARATOR, FIELD_KEY_PROG, FIELD_KEY_ACTION } from '../globals.ts'
import { RoundsModelFields } from './rounds_model.ts'

const ALIAS_ROUNDS = `${TABLE_ROUNDS}${FIELD_KEY_SEPARATOR}` as const

const PROG_VALUATION = `${FIELD_KEY_PROG}valuation` as const
const PROG_VALUATION_TYPE = `${FIELD_KEY_PROG}valuation_type` as const
const PROG_COMMITMENT = `${FIELD_KEY_PROG}commitment` as const
const PROG_ROUNDS_ACTION = `${FIELD_KEY_PROG}${TABLE_ROUNDS}${FIELD_KEY_ACTION}` as const

const FIELD_ROUNDS_ID = `${ALIAS_ROUNDS}${RoundsModelFields.id}` as const
const FIELD_ROUNDS_NAME = `${ALIAS_ROUNDS}${RoundsModelFields.name}` as const
const FIELD_ROUNDS_ACCOUNT = `${ALIAS_ROUNDS}${RoundsModelFields.account}` as const
const FIELD_ROUNDS_FUNDING_STAGE = `${ALIAS_ROUNDS}${RoundsModelFields.funding_stage}` as const
const FIELD_ROUNDS_CURRENCY = `${ALIAS_ROUNDS}${RoundsModelFields.currency}` as const
const FIELD_ROUNDS_RAISE_AMOUNT = `${ALIAS_ROUNDS}${RoundsModelFields.raise_amount}` as const
const FIELD_ROUNDS_PRE_MONEY_VALUATION = `${ALIAS_ROUNDS}${RoundsModelFields.pre_money_valuation}` as const
const FIELD_ROUNDS_POST_MONEY_VALUATION = `${ALIAS_ROUNDS}${RoundsModelFields.post_money_valuation}` as const
const FIELD_ROUNDS_SECURITY_TYPE = `${ALIAS_ROUNDS}${RoundsModelFields.security_type}` as const
const FIELD_ROUNDS_ROUND_CLOSE_DATE = `${ALIAS_ROUNDS}${RoundsModelFields.round_close_date}` as const

export const RoundEntrySchema = z
  .object({
    [FIELD_ROUNDS_ID]: z.string().nullish(),
    [FIELD_ROUNDS_NAME]: z.string().nullish(),
    [FIELD_ROUNDS_ACCOUNT]: z.string().nullish(),
    [FIELD_ROUNDS_FUNDING_STAGE]: z.string().nullish(),
    [FIELD_ROUNDS_CURRENCY]: z.string().nullish(),
    [FIELD_ROUNDS_RAISE_AMOUNT]: z.number().nullish(),
    [FIELD_ROUNDS_PRE_MONEY_VALUATION]: z.number().nullish(),
    [FIELD_ROUNDS_POST_MONEY_VALUATION]: z.number().nullish(),
    [FIELD_ROUNDS_SECURITY_TYPE]: z.string().nullish(),
    [FIELD_ROUNDS_ROUND_CLOSE_DATE]: z.string().nullish(),
    [PROG_VALUATION]: z.number().nullish(),
    [PROG_VALUATION_TYPE]: z.string().nullish(),
    [PROG_COMMITMENT]: z.number().nullish(),
    [PROG_ROUNDS_ACTION]: z.string().nullish()
  })
  .strict()

export const RoundEntryFields = makeFieldKeys(RoundEntrySchema)

export type RoundEntry = z.infer<typeof RoundEntrySchema>

export function validateRoundEntry(data: unknown): RoundEntry {
  try {
    return validateWithZodSchema(RoundEntrySchema, data, 'round entry')
  } catch (error) {
    throw new Error(`Round entry validation failed: ${error}`)
  }
}
